// OSIS - Stocuri Materiale - Inventar Materiale pardoseală, Low-E, securizată și laminată pentru OSIS
import React, { useState } from 'react';
import { 
  Package, Search, AlertTriangle, TrendingDown, TrendingUp, Plus,
  Truck, BarChart, Boxes, ShoppingCart, Clock, CheckCircle,
  Eye, Shield, Layers, Zap, ThermometerSun, Download, Edit
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const GlassStock = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('toate');
  const [isStockModalOpen, setIsStockModalOpen] = useState(false);
  const [selectedGlass, setSelectedGlass] = useState(null);
  const [isAddGlassModalOpen, setIsAddGlassModalOpen] = useState(false);

  // Mock data specific OSIS - stocuri Materiale realiste
  const mockGlassStock = [
    {
      id: 1,
      product: 'Materiale pardoseală 4+12+4 mm',
      category: 'pardoseală Standard',
      type: 'Dublu vitraj',
      thickness: '20mm total',
      quantity: 245,
      unit: 'mp',
      minStock: 150,
      maxStock: 400,
      status: 'în stoc',
      location: 'Depozit Materiale - Raft A1-A5',
      supplier: 'Mapei Romania',
      price: '45 RON/mp',
      lastOrder: '2024-03-15',
      lastDelivery: '2024-03-20',
      consumption: '85 mp/săptămână',
      features: ['Izolație termică', 'Transparență optimă', 'Rezistență standard'],
      applications: ['proiecte rezidențiale', 'lucrări balcon', 'proiecte birouri'],
      specifications: {
        thermalTransmittance: '2.8 W/m²K',
        lightTransmission: '81%',
        solarFactor: '0.75',
        soundInsulation: '32 dB'
      }
    },
    {
      id: 2,
      product: 'Materiale Low-E 4+16+4 mm',
      category: 'Low-E Performant',
      type: 'Dublu vitraj Low-E',
      thickness: '24mm total',
      quantity: 180,
      unit: 'mp',
      minStock: 100,
      maxStock: 300,
      status: 'în stoc',
      location: 'Depozit Materiale - Raft B1-B4',
      supplier: 'Pilkington Romania',
      price: '72 RON/mp',
      lastOrder: '2024-03-18',
      lastDelivery: '2024-03-22',
      consumption: '62 mp/săptămână',
      features: ['Eficiență energetică ridicată', 'Control solar', 'Izolație termică superioară'],
      applications: ['Case eficiente energetic', 'proiecte premium', 'Proiecte NZEB'],
      specifications: {
        thermalTransmittance: '1.1 W/m²K',
        lightTransmission: '76%',
        solarFactor: '0.61',
        soundInsulation: '35 dB'
      }
    },
    {
      id: 3,
      product: 'beton șlefuit 6mm',
      category: 'Securizată',
      type: 'Monoplan securizat',
      thickness: '6mm',
      quantity: 95,
      unit: 'mp',
      minStock: 80,
      maxStock: 200,
      status: 'stoc scăzut',
      location: 'Depozit Materiale - Raft C1-C2',
      supplier: 'Mapei Romania',
      price: '85 RON/mp',
      lastOrder: '2024-03-12',
      lastDelivery: '2024-03-16',
      consumption: '35 mp/săptămână',
      features: ['Rezistență la impact', 'Siguranță ridicată', 'Fragmentare controlată'],
      applications: ['lucrări intrare', 'Panouri laterale', 'Zone cu risc de impact'],
      specifications: {
        thermalTransmittance: '5.8 W/m²K',
        lightTransmission: '89%',
        solarFactor: '0.85',
        soundInsulation: '28 dB'
      }
    },
    {
      id: 4,
      product: 'Materiale Laminată 6.4mm (3+3)',
      category: 'Laminată',
      type: 'Monoplan laminat',
      thickness: '6.4mm',
      quantity: 65,
      unit: 'mp',
      minStock: 50,
      maxStock: 150,
      status: 'în stoc',
      location: 'Depozit Materiale - Raft D1',
      supplier: 'Pilkington Romania',
      price: '95 RON/mp',
      lastOrder: '2024-03-08',
      lastDelivery: '2024-03-12',
      consumption: '25 mp/săptămână',
      features: ['Securitate anti-efracție', 'Izolație fonică', 'Protecție UV'],
      applications: ['proiecte parter', 'lucrări securizate', 'Zone sensibile'],
      specifications: {
        thermalTransmittance: '5.7 W/m²K',
        lightTransmission: '87%',
        solarFactor: '0.76',
        soundInsulation: '36 dB'
      }
    },
    {
      id: 5,
      product: 'Triplu Vitraj 4+12+4+12+4 mm',
      category: 'Triplu Vitraj',
      type: 'Triplu vitraj premium',
      thickness: '36mm total',
      quantity: 35,
      unit: 'mp',
      minStock: 25,
      maxStock: 80,
      status: 'comandă necesară',
      location: 'Depozit Materiale - Raft E1',
      supplier: 'Mapei Romania',
      price: '125 RON/mp',
      lastOrder: '2024-02-28',
      lastDelivery: '2024-03-05',
      consumption: '18 mp/săptămână',
      features: ['Izolație termică maximă', 'Eficiență energetică premium', 'Confort acustic superior'],
      applications: ['Case passive', 'Proiecte premium', 'Zone cu cerințe speciale'],
      specifications: {
        thermalTransmittance: '0.7 W/m²K',
        lightTransmission: '74%',
        solarFactor: '0.56',
        soundInsulation: '42 dB'
      }
    },
    {
      id: 6,
      product: 'Materiale Colorată Bronz 6mm',
      category: 'Decorativă',
      type: 'Monoplan colorat',
      thickness: '6mm',
      quantity: 45,
      unit: 'mp',
      minStock: 30,
      maxStock: 100,
      status: 'în stoc',
      location: 'Depozit Materiale - Raft F1',
      supplier: 'Pilkington Romania',
      price: '68 RON/mp',
      lastOrder: '2024-03-05',
      lastDelivery: '2024-03-10',
      consumption: '12 mp/săptămână',
      features: ['Aspect estetic special', 'Control solar parțial', 'Intimitate sporită'],
      applications: ['Proiecte arhitecturale', 'Design interior', 'proiecte decorative'],
      specifications: {
        thermalTransmittance: '5.8 W/m²K',
        lightTransmission: '58%',
        solarFactor: '0.62',
        soundInsulation: '28 dB'
      }
    }
  ];

  // Filtrare stocuri Materiale
  const filteredGlass = mockGlassStock.filter(glass => {
    const matchesSearch = glass.product.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         glass.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         glass.supplier.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterCategory === 'toate' || glass.category === filterCategory;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalGlassTypes = mockGlassStock.length;
  const totalQuantity = mockGlassStock.reduce((acc, glass) => acc + glass.quantity, 0);
  const lowStockItems = mockGlassStock.filter(glass => glass.status === 'stoc scăzut' || glass.status === 'comandă necesară').length;
  const totalValue = mockGlassStock.reduce((acc, glass) => 
    acc + (glass.quantity * parseFloat(glass.price.replace(/[^\d]/g, ''))), 0
  );

  const columns = [
    { 
      key: 'product', 
      label: 'Tip Materiale', 
      render: (glass) => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-lg">
            <Layers className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <div className="font-medium text-gray-900 dark:text-white">{glass.product}</div>
            <div className="text-sm text-gray-500">{glass.type} • {glass.thickness}</div>
          </div>
        </div>
      )
    },
    { 
      key: 'category', 
      label: 'Categorie', 
      render: (glass) => (
        <Badge variant="default">
          {glass.category === 'pardoseală Standard' && <ThermometerSun className="w-3 h-3 mr-1" />}
          {glass.category === 'Low-E Performant' && <Zap className="w-3 h-3 mr-1" />}
          {glass.category === 'Securizată' && <Shield className="w-3 h-3 mr-1" />}
          {glass.category === 'Laminată' && <Layers className="w-3 h-3 mr-1" />}
          {glass.category === 'Triplu Vitraj' && <Eye className="w-3 h-3 mr-1" />}
          {glass.category === 'Decorativă' && <Eye className="w-3 h-3 mr-1" />}
          {glass.category}
        </Badge>
      )
    },
    { 
      key: 'quantity', 
      label: 'Stoc Actual', 
      render: (glass) => (
        <div className="text-right">
          <div className="font-semibold text-lg">{glass.quantity}</div>
          <div className="text-sm text-gray-500">{glass.unit}</div>
        </div>
      )
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (glass) => (
        <Badge 
          variant={
            glass.status === 'în stoc' ? 'success' : 
            glass.status === 'stoc scăzut' ? 'warning' : 'error'
          }
        >
          {glass.status === 'în stoc' && <CheckCircle className="w-3 h-3 mr-1" />}
          {glass.status === 'stoc scăzut' && <AlertTriangle className="w-3 h-3 mr-1" />}
          {glass.status === 'comandă necesară' && <ShoppingCart className="w-3 h-3 mr-1" />}
          {glass.status ? glass.status.charAt(0).toUpperCase() + glass.status.slice(1) : 'Necunoscut'}
        </Badge>
      )
    },
    { 
      key: 'price', 
      label: 'Preț', 
      render: (glass) => (
        <div className="text-right font-medium">
          {glass.price}
        </div>
      )
    },
    { 
      key: 'consumption', 
      label: 'Consum', 
      render: (glass) => (
        <div className="text-sm text-gray-600">
          {glass.consumption}
        </div>
      )
    }
  ];

  const handleGlassDetails = (glass) => {
    setSelectedGlass(glass);
    setIsStockModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Stocuri Materiale OSIS</h1>
          <p className="text-gray-600 dark:text-gray-400">Gestionarea stocurilor de Materiale pardoseală, Low-E, securizată și laminată</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddGlassModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Adaugă Tip Materiale</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Inventar</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Tipuri Materiale</p>
              <p className="text-3xl font-bold">{totalGlassTypes}</p>
            </div>
            <Layers className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Stoc Total</p>
              <p className="text-3xl font-bold">{totalQuantity}</p>
              <p className="text-green-200 text-sm">mp</p>
            </div>
            <Package className="w-8 h-8 text-green-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-yellow-500 to-yellow-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-yellow-100">Stoc Scăzut</p>
              <p className="text-3xl font-bold">{lowStockItems}</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-yellow-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Valoare Stoc</p>
              <p className="text-3xl font-bold">{Math.round(totalValue / 1000)}K</p>
              <p className="text-purple-200 text-sm">RON</p>
            </div>
            <BarChart className="w-8 h-8 text-purple-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare Materiale, categorie, furnizor..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-64">
            <select
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Categoriile</option>
              <option value="pardoseală Standard">pardoseală Standard</option>
              <option value="Low-E Performant">Low-E Performant</option>
              <option value="Securizată">Securizată</option>
              <option value="Laminată">Laminată</option>
              <option value="Triplu Vitraj">Triplu Vitraj</option>
              <option value="Decorativă">Decorativă</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel stocuri Materiale */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Inventar Materiale ({filteredGlass.length})
          </h2>
        </div>
        
        <Table 
          data={filteredGlass}
          columns={columns}
          onRowClick={handleGlassDetails}
        />
      </Card>

      {/* Modal Detalii Materiale */}
      <Modal
        isOpen={isStockModalOpen}
        onClose={() => setIsStockModalOpen(false)}
        title={selectedGlass ? `${selectedGlass.product}` : ''}
        size="xl"
      >
        {selectedGlass && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Tip & Categorie</label>
                  <p className="text-lg font-semibold">{selectedGlass.type}</p>
                  <p className="text-sm text-gray-600">{selectedGlass.category} • {selectedGlass.thickness}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Furnizor</label>
                  <p className="text-lg">{selectedGlass.supplier}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Locație Depozit</label>
                  <p className="text-lg">{selectedGlass.location}</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status Stoc</label>
                  <div className="mt-1">
                    <Badge 
                      variant={
                        selectedGlass.status === 'în stoc' ? 'success' : 
                        selectedGlass.status === 'stoc scăzut' ? 'warning' : 'error'
                      }
                    >
                      {selectedGlass.status ? selectedGlass.status.charAt(0).toUpperCase() + selectedGlass.status.slice(1) : 'Necunoscut'}
                    </Badge>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Cantitate & Progres</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                      <div 
                        className={`h-3 rounded-full ${
                          selectedGlass.quantity >= selectedGlass.minStock ? 'bg-green-500' : 'bg-red-500'
                        }`}
                        style={{ width: `${Math.min((selectedGlass.quantity / selectedGlass.maxStock) * 100, 100)}%` }}
                      ></div>
                    </div>
                    <span className="text-lg font-semibold">{selectedGlass.quantity} {selectedGlass.unit}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Min: {selectedGlass.minStock} • Max: {selectedGlass.maxStock}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Preț & Consum</label>
                  <p className="text-lg font-semibold text-primary-600">{selectedGlass.price}</p>
                  <p className="text-sm text-gray-600">{selectedGlass.consumption}</p>
                </div>
              </div>
            </div>

            {/* Specificații tehnice */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Specificații Tehnice</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <ThermometerSun className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Transmitanță Termică</span>
                  </div>
                  <p className="text-xl font-bold">{selectedGlass.specifications.thermalTransmittance}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Eye className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Transmisia Luminii</span>
                  </div>
                  <p className="text-xl font-bold">{selectedGlass.specifications.lightTransmission}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Zap className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Factor Solar</span>
                  </div>
                  <p className="text-xl font-bold">{selectedGlass.specifications.solarFactor}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Shield className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Izolația Fonică</span>
                  </div>
                  <p className="text-xl font-bold">{selectedGlass.specifications.soundInsulation}</p>
                </div>
              </div>
            </div>

            {/* Caracteristici */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Caracteristici Principale</h3>
              <div className="flex flex-wrap gap-2">
                {selectedGlass.features.map((feature, index) => (
                  <Badge key={index} variant="success">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    {feature}
                  </Badge>
                ))}
              </div>
            </div>

            {/* Aplicații */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Aplicații Recomandate</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {selectedGlass.applications.map((application, index) => (
                  <div key={index} className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
                    <div className="flex items-center space-x-2">
                      <Boxes className="w-4 h-4 text-blue-600" />
                      <span className="text-sm font-medium">{application}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Istoricul comenzilor */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Istoric Comenzi</h3>
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <div className="flex items-center space-x-2 mb-2">
                      <ShoppingCart className="w-4 h-4 text-gray-500" />
                      <span className="text-sm font-medium text-gray-500">Ultima Comandă</span>
                    </div>
                    <p className="font-semibold">{selectedGlass.lastOrder}</p>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 mb-2">
                      <Truck className="w-4 h-4 text-gray-500" />
                      <span className="text-sm font-medium text-gray-500">Ultima Livrare</span>
                    </div>
                    <p className="font-semibold">{selectedGlass.lastDelivery}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <ShoppingCart className="w-4 h-4" />
                  <span>Comandă Stoc</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Detalii</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <BarChart className="w-4 h-4" />
                  <span>Istoric Consum</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Download className="w-4 h-4" />
                  <span>Export Specificații</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Tip Materiale */}
      <Modal
        isOpen={isAddGlassModalOpen}
        onClose={() => setIsAddGlassModalOpen(false)}
        title="Adaugă Tip Materiale Nou"
        size="xl"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label className="label">Nume Produs</label>
              <input type="text" className="input" placeholder="ex: Materiale pardoseală 4+14+4 mm" />
            </div>
            <div>
              <label className="label">Categorie</label>
              <select className="input">
                <option>Selectează categoria...</option>
                <option>pardoseală Standard</option>
                <option>Low-E Performant</option>
                <option>Securizată</option>
                <option>Laminată</option>
                <option>Triplu Vitraj</option>
                <option>Decorativă</option>
              </select>
            </div>
            <div>
              <label className="label">Tip Materiale</label>
              <input type="text" className="input" placeholder="ex: Dublu vitraj" />
            </div>
            <div>
              <label className="label">Grosime Totală</label>
              <input type="text" className="input" placeholder="ex: 22mm total" />
            </div>
            <div>
              <label className="label">Furnizor</label>
              <select className="input">
                <option>Selectează furnizorul...</option>
                <option>Mapei Romania</option>
                <option>Pilkington Romania</option>
                <option>Saint-Gobain</option>
                <option>AGC Glass</option>
              </select>
            </div>
            <div>
              <label className="label">Cantitate Inițială</label>
              <input type="number" className="input" placeholder="ex: 150" />
            </div>
            <div>
              <label className="label">Stoc Minim</label>
              <input type="number" className="input" placeholder="ex: 100" />
            </div>
            <div>
              <label className="label">Preț (RON/mp)</label>
              <input type="number" className="input" placeholder="ex: 65" />
            </div>
            <div>
              <label className="label">Locație Depozit</label>
              <input type="text" className="input" placeholder="ex: Depozit Materiale - Raft G1" />
            </div>
            <div className="md:col-span-2">
              <label className="label">Caracteristici (separate prin virgulă)</label>
              <textarea className="input" rows="2" placeholder="ex: Izolație termică, Transparență optimă, Rezistență standard"></textarea>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddGlassModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Adaugă în Inventar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GlassStock;